export const skipNewPage = (url) => {
  if (window.webObject && window.webObject.loadUrlInBrowser) {
    window?.webObject?.loadUrlInBrowser(url)
  } else {
    window.open(
      url,
      "_blank"
    );
  }
}
